const ITEMS = [
    "HPLC verified",
    "≥99% purity",
    "Independent COA",
    "Australian cold chain",
    "Research use only",
    "Batch isolated",
    "Mass-spec confirmed",
    "Institutional supply",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="editorial-marquee" className="relative border-y border-slate-200 bg-white overflow-hidden py-5 select-none">
            <div className="flex w-max animate-marquee gap-0">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center shrink-0">
                        <span className="font-display text-lg md:text-xl font-light tracking-wide text-slate-700 px-6">{item}</span>
                        <span className="text-cyan-700 text-sm">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
